import React from "react";

const Footer = () => {
  let year = new Date().getFullYear();
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          © {year}
          <a href="https://ipactconsult.com/" target="_blank" rel="noreferrer">
            {""} IPACT Consult inc.
          </a>{" "}
          All rights reserved
        </p>
      </div>
    </div>
  );
};

export default Footer;
